import PropTypes from "prop-types";
import { css } from "@emotion/react";

import { NavLink } from "react-router-dom";

import MonitorIcon from "@/assets/svg/monitor.svg";
import CnsiIcon from "@/assets/svg/cnsi.svg";
import ControlIcon from "@/assets/svg/control.svg";
import AmbariIcon from "@/assets/svg/ambari.svg";
import NifiIcon from "@/assets/svg/nifi.svg";
import SettingIcon from "@/assets/svg/setting.svg";

import Hanwha from "@/assets/svg/hanwha.svg";

import Pablo from "@/assets/svg/pablo.svg";
import Weflo from "@/assets/svg/weflo.svg";

import ImageDoosan from "@/assets/svg/image-doosan.svg";

Navigation.propTypes = {};

function Navigation() {
  return (
    <div css={navigation}>
      <ul css={gnb}>
        <li>
          <NavLink className="hanwha" activeClassName="active" to="/butterfly">
            <div>
              <Hanwha className="logo" />
              <span>Hanwha butterfly</span>
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="pablo" activeClassName="active" to="/pablo">
            <div>
              <Pablo className="logo" />
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="dosan" activeClassName="active" to="/dosan">
            <div>
              <ImageDoosan className="logo" />
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="marine" activeClassName="active" to="/marine">
            <div>
              <img src="/images/image-marine.png" />
              {/*<ImageMarine className="logo" />*/}
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink
            className="quaternion"
            activeClassName="active"
            to="/quaternion"
          >
            <div>
              <img src="/images/image-quaternion.png" />
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="narma" activeClassName="active" to="/narma">
            <div>
              <img src="/images/image-narma.png" />
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="jysystem" activeClassName="active" to="/jysystem">
            <div>
              <img src="/images/image-jysystem.png" />
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="tie" activeClassName="active" to="/tie">
            <div>
              <img src="/images/image-tie.png" />
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="skyports" activeClassName="active" to="/skyports">
            <div>
              <img src="/images/image-skyports.png" />
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink className="weflo" activeClassName="active" to="/weflo">
            <div>
              <Weflo className="logo" />
              <span>Digital twin</span>
            </div>
            <MonitorIcon className="icon" />
          </NavLink>
        </li>

        <li>
          <a href="/control" className="weflo">
            <div>
              <Weflo className="logo" />
              <span>Vertiport</span>
            </div>
            <ControlIcon className="icon" />
          </a>
        </li>
        {/*
        <li>
          <NavLink activeClassName="active" to="/cnsi">
            <div>CNSi Dashboard</div>
            <CnsiIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/ambari">
            <div>Ambari</div>
            <AmbariIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/nifi">
            <div>Nifi</div>
            <NifiIcon className="icon" />
          </NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/setting">
            <div>Setting</div>
            <SettingIcon className="icon" />
          </NavLink>
        </li>
        */}
      </ul>
      <div css={brand}>
        <img src="/images/image-logo.png" alt="" />
      </div>
    </div>
  );
}

const navigation = (theme) => css`
  position: fixed;
  top: 60px;
  width: 220px;
  height: calc(100vh - 60px);
  background-color: #fff;
  z-index: ${theme.zIndex.LEVEL_5};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const gnb = (theme) => css`
  a {
    display: flex;
    padding: 22px 20px;
    justify-content: space-between;
    align-items: center;
    color: #ccc;
    transition: color, fill 0.3s;
  }

  a.narma {
    padding: 16px 20px;
  }

  a.narma img {
    width: 53px;
  }

  a.skyports {
    padding: 16px 20px;
  }

  a.skyports img {
    width: 78px;
  }

  a .icon {
    fill: #ccc;
  }

  a .logo {
    display: inline-block;
    fill: #ccc;
  }

  div {
    display: flex;
    align-items: center;
  }

  a.hanwha > div svg {
    width: 20px;
    margin-right: 4px;
  }

  a.weflo > div svg {
    width: 46px;
    margin-right: 4px;
  }

  a.pablo > div svg {
    width: 96.7px;
  }

  a:hover {
    color: ${theme.color.font};

    .logo {
      fill: ${theme.color.font};
    }

    .icon {
      fill: ${theme.color.font};
    }
  }

  a.active {
    background-color: ${theme.color.primary};
    color: #fff;

    .logo {
      fill: #fff;
    }

    .icon {
      fill: ${theme.color.sub};
    }
  }
`;

const brand = (theme) => css`
  width: 100%;
  padding-bottom: 30px;
  text-align: center;

  & > div {
    width: 88px;
    height: 20px;
    font-size: 0;
  }
`;

export default Navigation;
